<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div class="pbr_rules">
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="prio"
        class="elevation-1">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">NAT policy rules</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
            <div>
                <prefix_map_box v-model="show_ipv4_prefix_map_form"
                    @canceled="on_ipv4_prefix_map_form_cancel()"
                    @selected="on_ipv4_prefix_map_form_select($event)">
                </prefix_map_box>
            </div>

            <template v-slot:activator="{ props }">
                <v-btn @click="new_item()"
                    color="primary" dark class="mb-2"
                    v-bind="props">
                    Add NAT policy rule
                </v-btn>
            </template>

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                <v-card-title>
                    <span class="headline">{{ form_title }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.nat_policy_id"
                                label="NAT policy id"
                            ></v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.pos"
                                label="Rule position"
                            ></v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <div class="br_label">
                            Type
                            <treeselect
                                @input="on_rule_type_input()"
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.type"
                                :multiple="false" 
                                :options="rule_types"
                            />
                        </div>

                        <div v-if="edited_item.type === 0 || edited_item.type === 1">
                            <ValidationProvider rules="required|ipv4_prefix" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.ipv4_prefix"
                                    label="IPv4 prefix">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 2">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.ipset"
                                    label="IP set">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                
                        <div v-if="edited_item.type === 3 || edited_item.type === 4">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.prefix_map_id"
                                    label="Prefix map id">
                                <template v-if="edited_index == -1" #append>
                                    <v-btn @click="open_ipv4_prefix_map_form()">...</v-btn>
                                </template>                          
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div class="br_label">
                            Action
                            <treeselect
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.nat_action_id"
                                :multiple="false" 
                                :options="nat_actions"
                            />
                        </div>

                        <div v-if="edited_item.nat_action_id === 0 || edited_item.nat_action_id === 2">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-combobox
                                    v-model="edited_item.map_type"
                                    label="Map type"
                                    :items="map_types"
                                ></v-combobox>                    
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    :disabled="edited_item.nat_action_id !== 0"
                                    v-model="edited_item.map_id"
                                    label="Map id">
                                <template v-if="edited_index == -1" #append>
                                    <v-btn @click="open_ipv4_prefix_map_form()">...</v-btn>
                                </template>                          
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>                            
                        </div>                   
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn v-if="edited_index === -1" color="blue darken-1" 
                        :disabled="invalid" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-form></v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>   

        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small @click="delete_item(item)">
            mdi-delete
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import prefix_map_box from "../components/prefix_map_box.vue";
import "../validation_rules.js"

export default {

name: "nat_policy",

components: { 
    Treeselect, ValidationProvider, ValidationObserver,
    prefix_map_box
},

data: () => ({
    show_ipv4_prefix_map_form: false,
    search: '',
    dialog: false,
    headers: [
        { text: 'NAT policy id', value: 'nat_policy_id', align: 'start' },
        { text: 'Position', value: 'pos' },
        { text: 'Condition', value: 'cond' },
        { text: 'Policy action', value: 'action' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        type: -1,
        nat_policy_id: '',
        pos: '',
        cond: '',
        ipv4_prefix: '',
        ipset: '',
        prefix_map_id: '',
        nat_action_id: -1,
        map_type: '',
        map_id: '',
    },

    map_types: [
        'det_snat44',
        'snat44',
        'snat1to1',
    ],

    rule_types: [
          {
            id: -1,
            label: '',
          },
          {
            id: 0,
            label: 'from prefix',
          },
          {
            id: 1,
            label: 'to prefix',
          },
          {
            id: 2,
            label: 'from ipset',
          },
          {
            id: 3,
            label: 'from prefix map',
          },
          {
            id: 4,
            label: 'to prefix map',
          },
          {
            id: 5,
            label: 'default',
          },
        ],    

    nat_actions: [
        {
            id: -1,
            label: '',
        },
    ],

    nat_action_sets: [
        // nat type id 0 - from prefix
        [
            {
                id: -1,
                label: '',
            },
            {
                id: 0,
                label: 'map with id',
            },
        ],

        // nat type id 1 - to prefix
        [
            {
                id: -1,
                label: '',
            },            
            {
                id: 1,
                label: 'no NAT',
            },
        ],

        // nat type id 2 - from ipset
        [
            {
                id: -1,
                label: '',
            },
            {
                id: 0,
                label: 'map with id',
            },
        ],

        // nat type id 3 - from prefix map
        [
            {
                id: -1,
                label: '',
            },
            {
                id: 0,
                label: 'map with id',
            },
            {
                id: 2,
                label: 'map',
            },
        ],

        // nat type id 4 - to prefix map
        [
            {
                id: -1,
                label: '',
            },
            {
                id: 1,
                label: 'no NAT',
            },
        ],

        // nat type id 5 - default
        [
            {
                id: -1,
                label: '',
            },
            {
                id: 0,
                label: 'map with id',
            },
        ],
    ],         
}),

computed: {
    form_title() {
        return this.edited_index === -1 ? 'Add NAT policy rule' : 'NAT policy rule'
    },
},

watch: {
},

created() {
    this.initialize()
},

methods: {
    on_ipv4_prefix_map_form_cancel() {
        this.show_ipv4_prefix_map_form = false;
    },

    on_ipv4_prefix_map_form_select(prefix_map_id) {
        this.edited_item.prefix_map_id = prefix_map_id;
        this.show_ipv4_prefix_map_form = false;
    },

    open_ipv4_prefix_map_form() {
        this.show_ipv4_prefix_map_form = true;
    },

    initialize() {
        return new Promise((resolve, reject) => {
            api_client.run_get_query("/nat/nat_policy/show")
            .then(response => {
                this.items = response.data;
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    new_item() {
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });          
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.dialog = true;
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete NAT policy rule '" + 
            this.edited_item.cond + " -> " + this.edited_item.action + "', at position " + this.edited_item.pos + " ?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.run_post_query('/nat/nat_policy/del', {
            nat_policy_id: this.edited_item.nat_policy_id,
            pos: this.edited_item.pos,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
        this.items.splice(this.edited_index, 1);
    },

    save() {
        let type = this.edited_item.type;

        if (type === -1) {
            this.$fire({title: "Notice",
                text: 'undefined "Type" value', type: "warning"});
            return;
        }

        let cond = '';
        let action = '';
        let action_s;

        this.rule_types.forEach(i => {
            if (i.id == type) {
                cond = i.label;
            }
        });

        if (cond === '') {
            this.$fire({title: "Notice",
                text: 'incorrect "Type" value', type: "warning"});
            return;
        }

        if (type == 0 || type == 1) {
            // from prefix || to prefix
            cond = cond + ' ' + this.edited_item.ipv4_prefix;
        }
        else if (type == 2) {
            // from ipset
            cond = cond + ' ' + this.edited_item.ipset; 
        }
        else if (type == 3 || type == 4) {
            // from prefix map || to prefix map
            cond = cond + ' ' + this.edited_item.prefix_map_id;
        }

        if (this.edited_item.nat_action_id == 0) {
            if (this.edited_item.map_id === '') {
                this.$fire({title: "Notice",
                    text: 'undefined "Map id" value', type: "warning"});
                return;
            }
            // map with id
            action = 'map ' + this.edited_item.map_type + ' ' + this.edited_item.map_id;
            action_s = 'map ' + this.edited_item.map_type + ':' + this.edited_item.map_id;
        }
        else if (this.edited_item.nat_action_id == 1) {
            // no nat
            action = 'no nat';
            action_s = action;
        }
        else if (this.edited_item.nat_action_id == 2) {
            // map
            action = 'map ' + this.edited_item.map_type;
            action_s = action;
        }
        
        if (action === '') {
            this.$fire({title: "Notice",
                text: 'incorrect Action value', type: "warning"});
            return;
        }

        let prms = {
            nat_policy_id: this.edited_item.nat_policy_id,
            pos: this.edited_item.pos,
            cond: cond,
            action: action,
        };

        api_client.run_post_query('/nat/nat_policy/add', prms)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    nat_policy_id: this.edited_item.nat_policy_id,
                    pos: this.edited_item.pos,
                    cond: cond,
                    action: action_s,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });        
    },

    on_rule_type_input()
    {
        this.nat_actions = this.nat_action_sets[this.edited_item.type];
        this.edited_item.nat_action_id = -1;
    },    
},

};
</script>
